module.exports = __webpack_public_path__ + "static/media/cv-library.7a7e4396.png";